export const CSS_NAME = 'nds-mc-feedback';

export const css = {
	container: `${CSS_NAME}__container`,
	iconContainer: `${CSS_NAME}__icon-container`,
	icon: `${CSS_NAME}__icon`,
	iconCorrect: `${CSS_NAME}__icon--correct`,
	iconIncorrect: `${CSS_NAME}__icon--incorrect`,
	heading: `${CSS_NAME}__heading`,
};
